import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66667 3.33288H2L4.19333 1.13955C4.25582 1.07758 4.30541 1.00384 4.33926 0.922602C4.37311 0.841362 4.39053 0.754225 4.39053 0.666218C4.39053 0.57821 4.37311 0.491073 4.33926 0.409833C4.30541 0.328594 4.25582 0.25486 4.19333 0.192885C4.06842 0.0687177 3.89946 -0.000976562 3.72333 -0.000976562C3.54721 -0.000976562 3.37824 0.0687177 3.25333 0.192885L0.393333 3.05955C0.142942 3.30845 0.00148853 3.6465 0 3.99955C0.00324439 4.35028 0.144563 4.68561 0.393333 4.93288L3.25333 7.79954C3.31549 7.86126 3.3892 7.91014 3.47025 7.94337C3.55129 7.97661 3.63809 7.99356 3.72569 7.99325C3.81329 7.99294 3.89996 7.97538 3.98077 7.94157C4.06158 7.90776 4.13494 7.85837 4.19667 7.79621C4.25839 7.73405 4.30726 7.66034 4.3405 7.5793C4.37373 7.49825 4.39068 7.41145 4.39037 7.32385C4.39006 7.23626 4.3725 7.14958 4.33869 7.06877C4.30489 6.98796 4.25549 6.9146 4.19333 6.85288L2 4.66621H8.66667C8.84348 4.66621 9.01305 4.59597 9.13807 4.47095C9.26309 4.34593 9.33333 4.17636 9.33333 3.99955C9.33333 3.82274 9.26309 3.65317 9.13807 3.52814C9.01305 3.40312 8.84348 3.33288 8.66667 3.33288Z"
      fill="#151718"
    />
  </svg>
);

const ArrowLeft = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default ArrowLeft;
